<template lang="html">

  <section class="encabezado row-center">

    <h1>{{$t(`encabezado.${data}`)}}</h1>    
    

    <div class="migas-wrapper" v-if="showMigas">
      <div class="container">
        <migas :inicioPersonalizado="inicioPersonalizado" :last="last"></migas>
      </div>
    </div>

  </section>

</template>

<script lang="js">

  import migas from '@/components/parts/migas';

  import {mapGetters} from 'vuex';

  export default  {
    name: 'encabezado',
    props: ['data','inicioPersonalizado','last'],
    components : {
      'migas' : migas
    },
    computed : {
      ...mapGetters({
        colors : 'basicColors',
        background : 'getBackground',
        style : 'getStyles'
      }),
      showMigas : function(){
        let forbidden = ['/'];
        return !(forbidden.some(el => el == this.$route.path));
      }
    }
  }
</script>




// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/parts/encabezado.vue